import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap: LocalizedString = {
	[Locale.cs]: "/gdpr",
	[Locale.en]: "/gdpr",
	[Locale.sk]: "/gdpr",
};

export function getPrivacyPolicyPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
